import { useState } from "react";
import { saveBrandGroup } from "../Api/BrandGroup";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const BrandGroup = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [brandData, setBrandData] = useState({
    brandCode: "",
    description: "",
  });

  const handleChange = (e) => {
    setBrandData({ ...brandData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveBrandGroup(brandData);
      toast.success("🦄 Brand Group Added Successfully");
      setBrandData({
        brandCode: "",
        description: "",
      });
      
    } catch (error) {
      toast.error("🦄 Some Error Happened");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">Brand Group</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Brand Code <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="brandCode"
                      value={brandData.brandCode}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Description <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="description"
                      value={brandData.description}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save Brand Group
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default BrandGroup;